module.exports = "/_next/static/images/d4e305c54798899bd89d697e69a635c1-holding-card-vertical@0.75x.png";